import { useTheme } from 'styled-components';

/**
 * Use select styles
 * @returns {object} select list props with styles
 */
const useSelectStyle = () => {
  const theme = useTheme();
  return {
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: '#757575',
      fontSize: '14px',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999999999,
    }),
    control: (base, state) => ({
      ...base,
      minHeight: 48,
      border: state.selectProps.errorMessage
        ? `1px solid ${theme.COLOR_ERROR_TEXT}`
        : `1px solid ${theme.COLOR_GREY5}`,
      color: theme.COLOR_GREY_TEXT,
      boxShadow: 'none',
      '&:hover': {
        border: `1px solid ${theme.COLOR_BLACK}`,
      },
    }),
    option: (base, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      return {
        ...base,
        backgroundColor: 'transparent',
        color: state.isSelected ? theme.COLOR_BLACK : theme.COLOR_GREY_TEXT,
        fontWeight: state.isSelected ? 600 : 400,
        opacity,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.COLOR_BG_DARK,
        },
        fontSize: '14px',
      };
    },
    clearIndicator: (base) => ({
      ...base,
      color: theme.COLOR_GREY_TEXT,
      '&:hover': {
        color: theme.COLOR_BLACK,
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: theme.COLOR_GREY_TEXT,
      '&:hover': {
        color: theme.COLOR_BLACK,
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: theme.COLOR_BLACK,
      borderRadius: '6px',
      marginRight: '8px',
      marginLeft: '-3px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: theme.COLOR_WHITE,
      marginLeft: '6px',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: theme.COLOR_GREY4,
      ':hover': {
        color: theme.COLOR_WHITE,
        fontWeight: 600,
        cursor: 'pointer',
      },
    }),
    menuList: (base) => ({
      ...base,
      overflowY: 'scroll',
    }),
  };
};

export default useSelectStyle;
